import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FONT_FAMILY } from "../utils/constants";
import { getOptimisticSwitchErrorMessage } from "./copy";

const OptimisticSwitchFailureAlertBody = ({ copy, error }) => {
  const intro = String(copy?.intro || "").trim();
  const errorMessage = getOptimisticSwitchErrorMessage(error);

  return (
    <>
      {intro ? (
        <Typography
          variant="body1"
          sx={{
            fontFamily: FONT_FAMILY,
            textAlign: "center",
          }}
        >
          {intro}
        </Typography>
      ) : null}
      {errorMessage ? (
        <Box
          sx={{
            mt: intro ? 1.5 : 0,
            px: 1.5,
            py: 1.25,
            bgcolor: "#f3f4f6",
            borderRadius: "8px",
            textAlign: "left",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontFamily: FONT_FAMILY,
              color: "#374151",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {errorMessage}
          </Typography>
        </Box>
      ) : null}
    </>
  );
};

export default OptimisticSwitchFailureAlertBody;
